export const useLinksToTargetParent = (document: any | null) => {
  function setTargetToParent(event: any) {
    const a = event?.target?.closest('a')
    //console.log('event.target closest A: ', a)
    if (a && !a.hasAttribute("target")) {
      a.setAttribute("target", "_parent");
      //event.preventDefault()
    }
  }

  if (document) {
    //console.log('setTargetToParent added!')
    document.addEventListener("click", setTargetToParent); 
  }
  else {
    //console.log('setTargetToParent removed!')
    document.removeEventListener("click", setTargetToParent)
  }
}
